"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _submitButtonMessages = require("./submitButtonMessages");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SubmitBtn = function SubmitBtn(_ref) {
  var block = _ref.block,
    inputRef = _ref.inputRef,
    onClick = _ref.onClick;
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  var strings = block.strings || {};
  var buttonLabel = strings.label || formatMessage(_submitButtonMessages.submitButtonMessages.adyenButtonLabel);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-widget__submit-button"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn--primary",
    type: "button",
    onClick: onClick,
    ref: inputRef
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "adyen-checkout__button__content"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "adyen-checkout__button__text"
  }, buttonLabel))));
};
SubmitBtn.propTypes = {
  block: _propTypes.default.object.isRequired,
  inputRef: _propTypes.default.func.isRequired,
  onClick: _propTypes.default.func
};
var _default = SubmitBtn;
exports.default = _default;